import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center justify-center min-w-[50px] rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-border focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-beige text-heading border-0 font-normal",
        secondary:
          "border-transparent bg-surface text-btn-text hover:bg-btn-bg-hover hover:text-btn-text-hover",
        destructive:
          "border-transparent bg-red text-btn-text hover:bg-red-light hover:text-btn-text-hover",
        outline: "text-text border-border bg-bg hover:bg-btn-bg hover:text-btn-text",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
